import products from "../enums/products"

export const SET_PACKAGE = "SET_PACKAGE"
export const SET_MEDICAL_TIER = "SET_MEDICAL_TIER"
export const DEAL_TAGS_BLACKLIST = "blacklistTagIds"
export const DEAL_DEALS_BLACKLIST = "blacklistDealIds"

export const DEALS = products.deals
export const RECOGNITION = products.recognition
export const MEDICAL = products.medical
export const TENANT_WALLET = products.tenantWallet
export const USER_WALLET = products.userWallet
export const SSO_OPTIONS = products.ssoOptions
export const TENANT_ONBOARDING = products.tenantOnboarding
export const ZIP_PAYMENT = products.zipPayment
export const WELLNESS_HUB = products.wellnessHub
export const GLOBAL_BETA = products.globalBeta
export const REPORTING_BETA = products.reportingBeta

interface EnableDisable {
  [key: string]: string,
  [products.deals]: string,
  [products.recognition]: string,
  [products.medical]: string,
  [products.tenantWallet]: string,
  [products.userWallet]: string,
  [products.zipPayment]: string,
  [products.wellnessHub]: string,
  [products.globalBeta]: string,
  [products.reportingBeta]: string
}

export const ENABLE: EnableDisable = {
  [DEALS]: "ENABLE_PRODUCT_DEALS",
  [RECOGNITION]: "ENABLE_PRODUCT_RECOGNITION",
  [MEDICAL]: "ENABLE_PRODUCT_MEDICAL",
  [TENANT_WALLET]: "ENABLE_PRODUCT_TENANT_WALLET",
  [USER_WALLET]: "ENABLE_PRODUCT_USER_WALLET",
  [ZIP_PAYMENT]: "ENABLE_PAYMENTS_ZIP",
  [WELLNESS_HUB]: "ENABLE_WELLNESS_HUB",
  [GLOBAL_BETA]: "ENABLE_GLOBAL_BETA"
}

export const DISABLE: EnableDisable = {
  [DEALS]: "DISABLE_PRODUCT_DEALS",
  [RECOGNITION]: "DISABLE_PRODUCT_RECOGNITION",
  [MEDICAL]: "DISABLE_PRODUCT_MEDICAL",
  [TENANT_WALLET]: "DISABLE_PRODUCT_TENANT_WALLET",
  [USER_WALLET]: "DISABLE_PRODUCT_USER_WALLET",
  [ZIP_PAYMENT]: "DISABLE_PAYMENTS_ZIP",
  [WELLNESS_HUB]: "DISABLE_WELLNESS_HUB",
  [GLOBAL_BETA]: "DISABLE_GLOBAL_BETA"
}
